module.exports = __webpack_public_path__ + "media/images/flags/64/Nicaragua-3dd8c95a502bb1b4d76ca06833d429e1.png";